import { useState } from "react";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const norm = (s) => (s || "").trim().replace(/\s+/g, " ").toLowerCase();

export function PositionCombobox({ value, options = [], onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const typed = q.trim().replace(/\s+/g, " ");
  const exact = options.find((o) => norm(o) === norm(typed));
  const pick = (v) => { onChange(v); setQ(""); setOpen(false); };
  return <Popover open={open} onOpenChange={setOpen}><PopoverTrigger asChild>
    <Button type="button" variant="outline" role="combobox" data-testid="emp-position" className="w-full justify-between font-normal bg-card"><span className={value ? "" : "text-muted-foreground"}>{value || "Select position…"}</span><ChevronsUpDown className="h-4 w-4 opacity-50" /></Button>
  </PopoverTrigger><PopoverContent className="p-0 w-[--radix-popover-trigger-width] bg-card" align="start">
    <Command><CommandInput data-testid="emp-position-search" placeholder="Search or type new…" value={q} onValueChange={setQ} /><CommandList>
      <CommandEmpty>{typed ? "No match" : "No positions yet"}</CommandEmpty>
      <CommandGroup>{options.map((o) => <CommandItem key={o} value={o} data-testid={`pos-opt-${norm(o).replace(/\W+/g, "-")}`} onSelect={() => pick(o)}><Check className={`mr-2 h-4 w-4 ${value === o ? "opacity-100" : "opacity-0"}`} />{o}</CommandItem>)}</CommandGroup>
      {typed && !exact && <CommandGroup forceMount><CommandItem value={`__new__${typed}`} data-testid="pos-add-new" onSelect={() => pick(typed)}><Plus className="mr-2 h-4 w-4" />Add "{typed}"</CommandItem></CommandGroup>}
      {typed && exact && exact !== typed && <div className="px-2 py-1.5 text-xs text-muted-foreground" data-testid="pos-exists-hint">Already exists as "{exact}"</div>}
    </CommandList></Command>
  </PopoverContent></Popover>;
}
